import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * CommonNotification - Premium toast notifications utility.
 *
 * Usage:
 *   showNotification("Success message!", "success");
 *   showNotification("Error message!", "error");
 *
 * Types: "success" | "error" | "info" | "warning"
 */
export const showNotification = (message, type = "success") => {
  const options = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    style: {
      borderRadius: "12px",
      fontSize: "14px",
      fontWeight: "500",
      fontFamily: "Inter, sans-serif",
    },
  };

  switch (type) {
    case "success":
      toast.success(message, options);
      break;
    case "error":
      toast.error(message, options);
      break;
    case "info":
      toast.info(message, options);
      break;
    case "warning":
      toast.warn(message, options);
      break;
    default:
      toast(message, options);
  }
};

export default showNotification;
